// extracted by mini-css-extract-plugin
export default {"editHeader":"irnor oi_5p","editHeaderButtons":"NkXs_","editHeaderButton":"kFXPi","saveButton":"zwBqi kFXPi","cancelButton":"yEFbF kFXPi"};